/**
 * @file 开发者社区 Banner
 * @author WanZhongYun(wanzhongyun@baidu.com)
 */
import React from 'react';
import './style.less';

const DeveloperBanner: React.FC = () => {
    return (
        <div className="developer-community-banner-wrapper">
            <div className="developer-community-banner">
                <div className="banner-title-common banner-title">飞桨开发者社区</div>
                <div className="banner-title-common banner-sub-title">PaddlePaddle Community</div>
            </div>
        </div>
    );
};

export default DeveloperBanner;